module.exports = __webpack_public_path__ + "media/images/emblems/Hochdorf_LU-4bb00454951855b7580e979c266cba3a.png";